import { render } from "./BaseLargeButton.vue?vue&type=template&id=1a93018e&ts=true"
import script from "./BaseLargeButton.vue?vue&type=script&lang=ts"
export * from "./BaseLargeButton.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__